import { render, staticRenderFns } from "./header_index.vue?vue&type=template&id=19753d52&scoped=true"
import script from "./header_index.vue?vue&type=script&lang=js"
export * from "./header_index.vue?vue&type=script&lang=js"
import style0 from "./header_index.vue?vue&type=style&index=0&id=19753d52&prod&lang=css"
import style1 from "./header_index.vue?vue&type=style&index=1&id=19753d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19753d52",
  null
  
)

export default component.exports